export default {
  path: '/bilibili-ad',
  component: () => import('./BilibiliAd'),
  meta: {
    title: '青藤之恋',
    designWidth: 750,
    expireIn: 'Thu Dec 31 2099 08:00:00 GMT+0800 (China Standard Time)',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'FormData'
    }
  }
}
